/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hof_Page_TitleInputs */



/**
* | output |
* | --- |
* | "Hall of Fame" |
*
* @param {Hof_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const hof_page_title = /** @type {((inputs?: Hof_Page_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hof_Page_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Hall of Fame")
	if (locale === "es") return /** @type {LocalizedString} */ ("Hall of Fame")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Hall da Fama")
	if (locale === "it") return /** @type {LocalizedString} */ ("Hall of Fame")
	return /** @type {LocalizedString} */ ("Hall of Fame")
});